import Route from '@ember/routing/route'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'

export default class BookLibraryIndexRoute extends Route {
  @service router!: RouterService

  redirect() {
    void this.router.replaceWith('subscription-type.book-library.search')
  }
}
